import React from 'react'
import styled from 'styled-components'
import ContactDetails from './ContactDetails'
import ContactDetailsPreloader from './ContactDetailsPreloader'
import ContactInput from './ContactInput'
import Content from './Content'
import { useInboxStore } from '../../../../../stores/inbox/useInboxStore'
import { useMinSkeletonDuration } from '../skeleton/useMinSkeletonDuration'
import { inboxSkeletonSurface } from '../skeleton/inboxSkeletonStyles'

interface IMessagesProps {
    showSidebar?: boolean
}

const Messages: React.FC<IMessagesProps> = ({ showSidebar }) => {
    const { store: { fetchingConversations, selectedConversation, fetchingMessages } } = useInboxStore()

    const showConversationSkeleton = useMinSkeletonDuration(fetchingConversations)
    const showMessagesHeaderSkeleton = useMinSkeletonDuration(fetchingMessages)

    const header = showMessagesHeaderSkeleton
        ? <ContactDetailsPreloader />
        : <ContactDetails />

    const headerOrInput = (selectedConversation && !showConversationSkeleton)
        ? header
        : showConversationSkeleton
        ? <ContactInputPreloader />
        : <ContactInput />

    return (
        <Container>
            {headerOrInput}
            <Content $centered={!showSidebar} />
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    min-height: 0;
    /* Refine / Assistant dropdown opens upward; hidden overflow clips the menu */
    overflow: visible;
`

const ContactInputPreloader = styled.div`
    width: 100%;
    height: 68px;
    border-radius: 4px;
    ${inboxSkeletonSurface}
    margin-bottom: 2px;
`

export default Messages
